import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getAuth } from '@services/identity.service';
import { Sidenav, ZoomHeader } from '@molecules/index';
import { logsToAwsCloudWatch } from '@services/logger.service';
import { useTheme } from 'next-themes';

import { isZoomApp } from '@zoom-app/helpers';
const PresenterLayout = ({ children }) => {
  const { setTheme } = useTheme();

  const auth = getAuth();

  function logError(msg, url, lineNo, columnNo, error) {
    const errorMessage = msg?.toLowerCase();
    let errorType = 'BrowserError(window.onError): ';

    if (errorMessage.includes('script error')) {
      errorType = 'Script Error: ';
    }

    const body = {
      logMessage: errorType + msg,
      logData: {
        userId: auth?.id || '',
        url,
        error: { message: error.message, stack: error.stack },
        lineNo,
        columnNo,
        location: {
          host: window.location.host,
          hostname: window.location.hostname,
          href: window.location.href,
          origin: window.location.origin,
          pathname: window.location.pathname
        }
      }
    };
    logsToAwsCloudWatch(body);
  }
  const getLayout = () => {
    if (isZoomApp()) {
      return (
        <div className="flex flex-col h-screen">
          {<ZoomHeader {...children.type.Header} />}
          <div className="flex-1 bg-grey-50 overflow-y-auto">
            {children}
          </div>
        </div>
      );
    }

    return (
      <div className="h-screen flex">
        <Sidenav isLoggedIn={auth?.authType !== 'guestMode'} {...children.type.Header} />
        <div className="flex flex-1 grow flex-col h-full overflow-hidden bg-content1">
          {children}
        </div>
      </div>
    );
  };

  useEffect(() => {
    setTheme('light');
  }, []);

  useEffect(() => {
    window.onerror = logError;
  }, []);

  return getLayout();
};

PresenterLayout.propTypes = {
  children: PropTypes.node
};

export default PresenterLayout;
